import type { LibraryResourceKind } from '@digital-twins/shared-types'

/** Shared order with the existing paged collection picker. */
export const PICKER_RESOURCE_KINDS: ReadonlyArray<LibraryResourceKind> = ['study', 'audience', 'dataset', 'document']
export const PICKER_SEARCH_DEBOUNCE_MS = 250
